import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const ScreenStyles = styled(OnboardingPage)``;

export const ImagesContainerStyles = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

export const ImageHalfStyles = styled.div<{ side: 'left' | 'right' }>`
  flex: 1;
  height: 100%;
  overflow: hidden;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
  }
`;

export const GradientBorderStyles = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 1px;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.2) 0%,
    #ffffff 50%,
    rgba(255, 255, 255, 0.2) 100%
  );
  z-index: 4;
  pointer-events: none;
`;

export const ContentOverlayStyles = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 3;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 24px 16px 24px;
  background: linear-gradient(
    180deg,
    rgba(20, 17, 30, 0) 32.02%,
    rgba(20, 17, 30, 0.5) 47.76%,
    #14111e 79.42%
  );
`;

export const TitleStyles = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  color: #ffffff;
  margin: 0 0 24px;
`;

export const OptionsContainerStyles = styled.div`
  display: flex;
  gap: 16px;
`;

export const OptionStyles = styled.button<{ isSelected: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px;
  background: ${({ isSelected }) =>
    isSelected ? 'rgba(128, 62, 255, 0.3)' : 'transparent'};
  border: none;
  border-radius: 16px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:active {
    background: rgba(128, 62, 255, 0.3);
  }
`;

export const GenderIconStyles = styled.div<{ gender: 'female' | 'male' }>`
  color: #ffffff;

  svg {
    width: 100%;
    height: 100%;
  }
`;
